import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_HOME: '/page/get/home',
    GET_MATCHES: '/page/get/matches',
    GET_MATCH: '/page/get/match',
    GET_PLAYER: '/page/get/player',
    GET_TEAM: '/page/get/team',
    GET_TOURNAMENT: '/page/get/tournament'
};

export const PageService = {
    getHome: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_HOME);
    },
    getMatches: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_MATCHES, params);
    },
    getMatchDetail: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_MATCH, { id });
    },
    getPlayerDetail: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_PLAYER, { id });
    },
    getTeamDetail: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_TEAM, { id });
    },
    getTournamentDetail: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_TOURNAMENT, params);
    },
};

export default PageService;
